import { DocType } from './index';
import { ImageFormat } from './image-format.enum';

export class DmsDocumentRqst {
  referenceNbr: string;
  proNbr: string;
  docType: DocType;
  imageFormat: ImageFormat;
}
